module.exports = __webpack_public_path__ + "static/img/SuperticketElefanteC.b34a469.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SuperticketElefanteC.png
// module id = wlpR
// module chunks = 1